module.exports = __webpack_public_path__ + "img/11.08842196.jpg";